import { kitchenTodayISO, kitchenTomorrowISO } from '@/features/kitchen/lib/kitchenDates'

export type DadakanShipmentLike = {
  tripDate?: string
  status: string
  storeName: string
  lines: { productName: string; qty: number }[]
}

export type DadakanConflict = {
  storeName: string
  products: string[]
}

function norm(name: string): string {
  return name.trim().toLowerCase()
}

/** Kiriman trip_date=besok yang belum PIN (draft / prepared). */
export function listUnpinnedTomorrowDrafts(
  shipments: DadakanShipmentLike[],
  todayIso = kitchenTodayISO(),
  tomorrowIso = kitchenTomorrowISO(),
): DadakanShipmentLike[] {
  return shipments.filter((s) => {
    const trip = (s.tripDate || todayIso).trim()
    if (trip !== tomorrowIso) return false
    return s.status === 'draft' || s.status === 'prepared'
  })
}

/**
 * Konflik dadakan (D8): produk yang overlap antara aksi hari ini dan draft besok belum PIN.
 * Jika `productNames` kosong → semua draft besok dianggap konflik (peringatan generik).
 */
export function findDadakanConflicts(
  shipments: DadakanShipmentLike[],
  productNames: string[],
  todayIso = kitchenTodayISO(),
  tomorrowIso = kitchenTomorrowISO(),
): DadakanConflict[] {
  const tomorrowDrafts = listUnpinnedTomorrowDrafts(shipments, todayIso, tomorrowIso)
  if (tomorrowDrafts.length === 0) return []

  const wanted = new Set(productNames.map(norm).filter(Boolean))
  const out: DadakanConflict[] = []

  for (const draft of tomorrowDrafts) {
    const draftProducts = draft.lines
      .filter((l) => l.qty > 0 && l.productName.trim())
      .map((l) => l.productName.trim())

    if (wanted.size === 0) {
      out.push({
        storeName: draft.storeName,
        products: [...new Set(draftProducts)],
      })
      continue
    }

    const overlap = [...new Set(draftProducts.filter((p) => wanted.has(norm(p))))]
    if (overlap.length > 0) {
      out.push({ storeName: draft.storeName, products: overlap })
    }
  }

  return out
}

export function isTripDateToday(tripDate: string | undefined, todayIso = kitchenTodayISO()): boolean {
  return (tripDate || todayIso).trim() === todayIso
}
